import React from 'react'

import { ButtonProps } from './Button.types'

import './Button.scss'
import { ArrowClockwise } from 'react-bootstrap-icons'

const ICON_SIZE = 18

export const Button: React.FC<ButtonProps> = ({ children, loading, ...props }) => (
  <button 
    type="button"
    data-testid="Button" 
    className="poll-button" 
    {...props}
  >
    {loading && <ArrowClockwise className="spin" size={ICON_SIZE} style={{ fill: props.disabled ? 'var(--slate10)' : 'white' }}/>}
    {children}
  </button>
)

export default Button